// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
    production: false,
    firebase: {
        // projectId: 'hundskolan',
        // appId: '1:301793581298:web:f0f30cd281954e5b75586b',
        // databaseURL: 'https://hundskolan-default-rtdb.europe-west1.firebasedatabase.app',
        // storageBucket: 'hundskolan.appspot.com',
        // apiKey: 'AIzaSyA7Uqjq5f2xp7LMH4p8RbCu9tjGCK5kxYk',
        // authDomain: 'hundskolan.firebaseapp.com',
        // messagingSenderId: '301793581298',
        // provider: 'anonymous',
        // uid: '58877a89-1c66-4183-8dc4-c067f4084d76'
        apiKey: 'AIzaSyA2AO9UfUwL0iznXSqnqK64fycfBMEbS_s',
        authDomain: 'hundskolan-vision.firebaseapp.com',
        databaseURL: 'https://hundskolan-vision-default-rtdb.europe-west1.firebasedatabase.app',
        projectId: 'hundskolan-vision',
        storageBucket: 'hundskolan-vision.appspot.com',
        messagingSenderId: '229545544935',
        appId: '1:229545544935:web:11db8799379070d10c6642',
        measurementId: 'G-8T34RJJF1F',
        provider: 'anonymous',
    },
    owncload: {
        user: 'hundskolanvision',
        password: 'Kktc8-ABny5-xMqKM-9FJxL-EDnCQ',
        url: '/webdav/'
    },
    wooCommerce: {
        category: 36
    },
    vimeo: {
        token: 'dcb8c4aa65aa7447296ffdfe641bf534'
    }
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
